import axios from "axios";

const { REACT_APP_SERVER_URL } = process.env;

export async function getProjects() {
  const sendQuery = await axios.get(`${REACT_APP_SERVER_URL}/projects`);
  return sendQuery.data;
}

export async function getProject(id) {
  const sendQuery = await axios.get(`${REACT_APP_SERVER_URL}/projects/${id}`);
  return sendQuery.data;
}
